import { Expand, X } from 'lucide-react'
import { useI18n } from '../../i18n'
import { DefendSphereAiConversation } from './DefendSphereAiConversation'
import { useDefendSphereAi } from './DefendSphereAiProvider'
import './defendsphere-ai.css'

export function DefendSphereAiPanel() {
  const { conversation, close, openWorkspace } = useDefendSphereAi()
  const { t } = useI18n()

  return (
    <>
      <div
        className="ds-ai-panel-backdrop"
        aria-hidden
        onClick={() => {
          if (conversation.pendingDisclosure?.required) return
          close()
        }}
      />
      <aside
        id="ds-ai-panel"
        className="ds-ai-panel"
        role="complementary"
        aria-label={t('complianceCenterUi.defendSphereAi.panelTitle', 'DefendSphere AI')}
      >
        <header className="ds-ai-panel__header">
          <div>
            <h2 className="ds-ai-panel__title">
              {t('complianceCenterUi.defendSphereAi.productName', 'DefendSphere AI')}
            </h2>
            <p className="ds-ai-panel__subtitle">
              {t('complianceCenterUi.defendSphereAi.subtitle', 'AI CISO')}
            </p>
          </div>
          <div className="ds-ai-panel__actions">
            <button
              type="button"
              className="ds-ai-icon-btn"
              aria-label={t('complianceCenterUi.defendSphereAi.expandWorkspace', 'Open full workspace')}
              onClick={openWorkspace}
            >
              <Expand aria-hidden />
            </button>
            <button
              type="button"
              className="ds-ai-icon-btn"
              aria-label={t('complianceCenterUi.defendSphereAi.closePanel', 'Close AI panel')}
              onClick={() => {
                if (conversation.pendingDisclosure?.required && conversation.disclosureBusy) return
                close()
              }}
            >
              <X aria-hidden />
            </button>
          </div>
        </header>
        <div className="ds-ai-panel__body">
          <DefendSphereAiConversation api={conversation} t={t} compact showHistory />
        </div>
      </aside>
    </>
  )
}
